import React from "react";
import { Link } from "react-router-dom";

export default function ProfilePromotionalHistory({ show, onClose, history = [], loading, profileID }) {
  if (!show) return null;

  return (
    <React.Fragment>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        style={{ display: show ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="promotionHistoryLabel"
        aria-hidden={!show}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="promotionHistoryLabel">
                Promotion History {profileID ? `(${profileID})` : ""}
              </h5>
              <button type="button" className="close" onClick={onClose} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <table
                  className="table table-striped table-bordered bulk_action mytable"
                  cellPadding="0"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th style={{ width: "20px" }}>S.No</th>
                      <th style={{ width: "100px" }}>Date</th>
                      <th style={{ width: "150px" }}>Profile</th>
                      <th style={{ width: "200px" }}>Listing</th>
                      <th style={{ width: "200px" }}>Position</th>
                      <th style={{ width: "200px" }}>No. of Views</th>
                      <th style={{ width: "200px"}} >	No. of Connect</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history && history.length > 0 ? (
                      history.map((item, idx) => (
                        <tr key={item._id || idx}>
                          <td>{idx + 1}</td>
                          <td>
                            {item.fromDate
                              ? new Date(item.fromDate).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                          <td>
                            <Link># {item?.member_id?.profile_id || "-"}</Link>
                            <p> {item?.member_id?.name || "-"}</p>
                           
                          </td>
                          <td>{item.listing || "-"}</td>
                          <td>{item.position || "-"}</td>
                          <td>{item.noOfViews || 0}</td>
                          <td>{item.noOfCConnects || 0}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No history available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} />
    </React.Fragment>
  );
}
